module.exports = __webpack_public_path__ + "img/H2.d74a7f6c.png";